import { render, staticRenderFns } from "./PhisicalPerson.vue?vue&type=template&id=4e2af8b8"
import script from "./PhisicalPerson.vue?vue&type=script&lang=js"
export * from "./PhisicalPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports